var moreLessButtons = document.querySelectorAll(".moreless-button");
var lineLimits = document.querySelectorAll(".line-limit");

if (moreLessButtons.length === lineLimits.length) {
  moreLessButtons.forEach(function (button, index) {
    button.addEventListener("click", function () {
      // Toggle the visibility of the associated "line-limit" paragraph
      if (lineLimits[index].style.height === "auto") {
        lineLimits[index].style.height = "4.2em";
        button.innerText = "Read More";
      } else {
        lineLimits[index].style.height = "auto";
        button.innerText = "Show Less";
      }
    });
  });
}

// Fortune cookie event listener
document.addEventListener("DOMContentLoaded", () => {
    const fortuneImg = document.querySelector(".fortune-img");
    const fortuneHeader = document.querySelector(".fortune-header");
    const topLeftSvg = document.querySelector(".top-left-svg");
    const bottomRightSvg = document.querySelector(".bottom-right-svg");
    const buttonContainer = document.getElementById("buttonContainer"); 
    // Array of cracked fortune cookie images
    const crackedFortunes = [
        "https://cdn.shopify.com/s/files/1/0679/0702/7174/files/cracked-fortune-cookie_2.png?v=1738009598",
        "https://cdn.shopify.com/s/files/1/0679/0702/7174/files/cracked-fortune-cookie_1.png?v=1738011492",
        "https://cdn.shopify.com/s/files/1/0679/0702/7174/files/cracked-fortune-cookie_3.png?v=1738012151",
        "https://cdn.shopify.com/s/files/1/0679/0702/7174/files/cracked-fortune-cookie_10.png?v=1738012151",
        "https://cdn.shopify.com/s/files/1/0679/0702/7174/files/cracked-fortune-cookie_13.png?v=1738012150",
        "https://cdn.shopify.com/s/files/1/0679/0702/7174/files/cracked-fortune-cookie_4.png?v=1738012151",
        "https://cdn.shopify.com/s/files/1/0679/0702/7174/files/cracked-fortune-cookie_5.png?v=1738012151",
        "https://cdn.shopify.com/s/files/1/0679/0702/7174/files/cracked-fortune-cookie_9.png?v=1738012151",
        "https://cdn.shopify.com/s/files/1/0679/0702/7174/files/cracked-fortune-cookie_8.png?v=1738012151",
        "https://cdn.shopify.com/s/files/1/0679/0702/7174/files/cracked-fortune-cookie_12.png?v=1738012151",
        "https://cdn.shopify.com/s/files/1/0679/0702/7174/files/cracked-fortune-cookie_15.png?v=1738012151",
        "https://cdn.shopify.com/s/files/1/0679/0702/7174/files/cracked-fortune-cookie_11.png?v=1738012150",
        "https://cdn.shopify.com/s/files/1/0679/0702/7174/files/cracked-fortune-cookie_14.png?v=1738012151",
        "https://cdn.shopify.com/s/files/1/0679/0702/7174/files/cracked-fortune-cookie_6.png?v=1738012150",
        "https://cdn.shopify.com/s/files/1/0679/0702/7174/files/cracked-fortune-cookie_7.png?v=1738012151"
    ];
    // Preload all cracked fortune cookie images
    crackedFortunes.forEach(src => {
        const img = new Image();
        img.src = src;
    });
    // Event listener for the fortune image click
    fortuneImg.addEventListener("click", () => {
        const randomIndex = Math.floor(Math.random() * crackedFortunes.length);
        const randomCrackedCookie = crackedFortunes[randomIndex];
        fortuneImg.src = randomCrackedCookie; // Set the cracked cookie image
        fortuneImg.classList.add("cracked-fortune-image");     
        if (fortuneHeader) {
            fortuneHeader.style.display = "none";
        }
        fortuneImg.style.pointerEvents = "none";
        topLeftSvg.style.display = "block";
        bottomRightSvg.style.display = "block"; 
        buttonContainer.classList.remove("hidden");
    });
});

function saveImage() {
    const img = document.querySelector(".fortune-img");
    const imgSrc = img.src;
    const link = document.createElement("a");
    link.href = imgSrc;
    link.download = "by-kind-fortune-cookie.png"; // File name for download
    link.click();
}
function shareImage() {
    const imgUrl = document.querySelector(".fortune-img").src;
    const pageUrl = window.location.href;
    if (navigator.share) {
        navigator.share({
            title: "Fortune Cookie Image",
            text: `Check out this fortune cookie image: ${imgUrl}. Visit By Kind for your own fortune!`,
            url: pageUrl, // Share the page URL
        })
        .then(() => console.log("Shared successfully"))
        .catch((error) => console.error("Error sharing:", error));
    } else {
        alert("Share functionality is not supported in your browser.");
    }
}
